import {AiQuestion} from '../message/AiQuestion';
import {AiQuestionCriteria} from './AiQuestionCriteria';
import {AiQuestionScenario} from './AiQuestionScenario';
import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';

export class AiQuestionWrapper extends BaseWrapper<AiQuestion, AiQuestionCriteria, AiQuestionScenario>  {}

